<div class="alert-box" [class]="type()" nhaTest="alert-box">
	<mat-icon>{{ icon() }}</mat-icon>
	<span>
		@if (message()) {
			{{ message() }}
		} @else {
			<ng-content />
		}
	</span>
</div>
